// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"327c69e8","993":"04c340d1"}[chunkId] + ".chunk.css";
};